import styled from "styled-components";

import { card, layout } from "/styles";

import Divider from "../Divider";
import { ListItemWrapperProps } from "./List.types";

export const BaseLi = styled.li<ListItemWrapperProps>`
  ${({ theme, $newDesign }) => layout.paddingHorizontal($newDesign ? "none" : "gutter")({ theme })};
  ${({ theme, $hideResponsiveStates }) =>
    !$hideResponsiveStates &&
    `
    &:hover {
      background-color: ${theme.colors.backgroundSurfaceHover};
    }
    &:active {
      background-color: ${theme.colors.backgroundSurfaceActive};
    }
  `}
`;

export const ListDivider = styled(Divider)<{ $isListItemClickable?: boolean }>`
  ${({ theme, $isListItemClickable = true }) =>
    $isListItemClickable
      ? layout.margin("none", "none", "none", "gutter")({ theme })
      : layout.marginHorizontal("gutter")({ theme })}
`;

export const NewDesignItemContainer = styled.div(
  card.base,
  layout.flexCenterHorizontal,
  layout.paddingVertical("condensed"),
  ({ theme }) => ({
    width: "100%",
    padding: theme.spacing.standard,
    marginBottom: theme.spacing.standard,
  }),
);
